import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ButtonBase, Stack, Typography } from '@mui/material';
import {
  ThumbContainer,
  ThumbImage,
  ThumbOverlay,
  Container,
  Progress,
  MissingImageContainer,
} from './styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import images from 'src/config/images';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MissingImage from 'src/modules/lms/shared/MissingImage';
import SessionPreview from './SessionPreview';
import { addList, deleteList } from 'src/modules/lms/api/LMSApis';
import toast from 'src/utils/toast';
import VideoFrame from '../VideoFrame';
import SessionStatus from './SessionStatus';

import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import EjectIcon from '@mui/icons-material/Eject';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { NotStarted } from 'src/modules/lms/shared/icons';

function Thumbnail({ session, categoryType }) {
  const [showModal, setShowModal] = useState(false);
  const [fav, setFav] = useState(session?.isFavourite);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const thumbnailImage = (session?.thumbnailImage || '').trim();
  const history = useHistory();
  const totalVideos = session?.videos?.length || 0;
  const [watchedVideos, setWatchedVideos] = useState(0);
  const [inProgressVideos, setInProgressVideos] = useState(0);

  const calculateNumberOfVideos = () => {
    const watched = session?.history?.filter((item) => {
      if (item?.isFullyWatched === true || item?.watchedDuration == item?.totalDuration)
        return item;
    });

    const progress = session?.history?.filter((item) => {
      let totalDuration = parseInt(item?.totalDuration);
      let watchedDuration = parseInt(item?.watchedDuration);
      if (totalDuration > watchedDuration) return item;
    });
    setInProgressVideos(progress?.length || 0);
    setWatchedVideos(watched?.length || 0);
  };

  useEffect(() => {
    calculateNumberOfVideos();
  }, [session]);

  const handleClick = () => {
    if (categoryType === 'recruitment') {
      history.push(`session/${session.id}`);
    } else {
      history.push(`lms/session/${session.id}`);
    }
  };
  const showPreview = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setShowModal(true);
  };
  const addInFavList = async (id) => {
    try {
      let payload =
        session.contentType === 'session'
          ? {
              session: id,
            }
          : { course: id };

      let res = await addList(payload);
      if (res) {
        if (res?.message) {
          toast.info('Already added to My List');
        } else {
          toast.success('Item added to My list');
        }
        setFav(true);
      } else {
        toast.error('Item not added to My list');
      }
    } catch (error) {
      toast.error('Item not added to My list');
      console.error('Error in adding item to the My list :', error);
    }
  };

  const removeFromList = async (id) => {
    try {
      let res = await deleteList(id);
      if (res) {
        toast.info('Item removed from My list');
        setFav(false);
      } else {
        toast.error('Item not removed from My list');
      }
    } catch (error) {
      toast.error('Error ocurred! Please try again.');
      console.error('Error in adding item to the My list :', error);
    }
  };

  const [hover, setHover] = useState(false);
  const [mainVideo, setMainVideo] = useState('');
  useEffect(() => {
    session?.videos?.map((video) => {
      if (video?.isPrimaryVideo === true) {
        setMainVideo(video?.videoUrl);
      }
    });
  }, []);

  const handlePlay = (event) => {
    event.stopPropagation();
    event.preventDefault();
    history.push(`/lms/session/${session.id}`);
  };

  return (
    <>
      <Container onClick={handleClick}>
        <ThumbContainer
          onMouseEnter={() => {
            setHover(true);
          }}
          onMouseLeave={() => {
            setHover(false);
          }}
        >
          {thumbnailImage && thumbnailImage != '' ? (
            <ThumbImage src={thumbnailImage} />
          ) : (
            <MissingImageContainer>
              <MissingImage />
            </MissingImageContainer>
          )}
          <SessionStatus session={session} hover={hover} fav={fav} />
        </ThumbContainer>
        <ThumbOverlay
          onMouseEnter={() => {
            setHover(true);
          }}
          onMouseLeave={() => {
            setHover(false);
          }}
        >
          <Stack direction="row" gap={1}>
            <ButtonBase onClick={showPreview}>
              <VisibilityIcon sx={{ fill: '#13DEA1' }} />
            </ButtonBase>
            <ButtonBase onClick={handlePlay}>
              {totalVideos > 0 && totalVideos === watchedVideos ? (
                <RestartAltIcon />
              ) : totalVideos > 0 && inProgressVideos > 0 ? (
                <EjectIcon sx={{ transform: 'rotate(90deg)' }} />
              ) : (
                <PlayArrowIcon />
              )}
            </ButtonBase>
            <ButtonBase
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                if (fav) {
                  removeFromList(session.id);
                } else {
                  addInFavList(session.id);
                }
              }}
            >
              {fav ? (
                <StarIcon sx={{ fill: 'rgba(255, 212, 126, 1)' }} />
              ) : (
                <StarBorderIcon sx={{ fill: 'rgba(255, 212, 126, 1)' }} />
              )}
            </ButtonBase>
          </Stack>
        </ThumbOverlay>
        {session?.history.length ? (
          <Progress>
            {totalVideos === watchedVideos ? (
              <>
                <CheckCircleIcon sx={{ width: '16px', height: '16px' }} />
                <Typography variant="caption" className="status">
                  Watched
                </Typography>
              </>
            ) : (
              <>
                <img src={images.LMS.progress} />
                <Typography variant="caption" className="status">
                  In Progress
                </Typography>
              </>
            )}
            {totalVideos === watchedVideos ? (
              <Typography variant="caption" className="count">
                {watchedVideos} of {totalVideos}
              </Typography>
            ) : (
              <Typography variant="caption" className="count">
                {inProgressVideos} of {totalVideos}
              </Typography>
            )}
          </Progress>
        ) : null}
      </Container>
      <SessionPreview
        session={session}
        open={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
      />
      <VideoFrame
        VideoUrl={mainVideo}
        open={videoModalOpen}
        handleClose={() => setVideoModalOpen(false)}
        handleOpen={() => setVideoModalOpen(true)}
      />
    </>
  );
}

export default Thumbnail;
